var _excluded = ["displayType"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { AuctionResultCard } from './listing-cards/auction-result-card';
import { DefaultListingCard } from './listing-cards/default-listing-card';
import { NewDevelopmentsCard } from './listing-cards/new-developments-card';
import * as events from './models/events';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BaseAllhomesListingCard = _ref => {
  var _ref$displayType = _ref.displayType,
    displayType = _ref$displayType === void 0 ? 'default' : _ref$displayType,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var onClick = listingId => {
    sendEvent(events.cardClick, {
      listingId: props.id
    });
    if (props.onClick) {
      props.onClick(listingId);
    }
  };
  switch (displayType) {
    case 'auction':
      return ___EmotionJSX(AuctionResultCard, _extends({}, props, {
        onClick: onClick
      }));
    case 'newdevelopments':
      return ___EmotionJSX(NewDevelopmentsCard, _extends({}, props, {
        onClick: onClick
      }));
    default:
      return ___EmotionJSX(DefaultListingCard, _extends({}, props, {
        onClick: onClick
      }));
  }
};
export var AllhomesListingCard = withEventBoundary({
  name: 'listing-card'
})(BaseAllhomesListingCard);